import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `dashboard/verticals/${path}`;

export function fetchVerticals() {
  return defaultClient.request({
    url: URL(''),
  });
}

export function fetchVerticalsForClient(clientId) {
  return defaultClient.request({
    url: URL('for-client/'),
    options: { params: { client_id: clientId } },
  });
}

export function fetchClientVerticalOptions({ clientId }) {
  if (!clientId) {
    return Promise.resolve({ data: [] });
  }
  return defaultClient.request({
    url: 'dashboard/client-zips/vertical_options/',
    options: {
      params: { client_id: clientId },
    },
  });
}
